import React from "react";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { convertImageToWebp } from "./hooks/convertToWebp";
import "./styles/AttachmentsInput.css";

const SortableItem = ({ id, url, mime, onRemove }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    animateLayoutChanges: () => true,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? "none" : transition,
    zIndex: isDragging ? 10 : undefined,
    pointerEvents: "auto",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="attachment-item"
      {...attributes}
    >
      <div {...listeners} className="drag-handle">
        {mime.startsWith("video") ? (
          <div className="video-thumb">
            <video src={url} muted loop preload="metadata" />
            <div className="video-overlay">🎥</div>
          </div>
        ) : (
          <img src={url} className="attachment-preview" alt="attachment" />
        )}
      </div>
      <button onClick={() => onRemove(id)} className="remove-button">
        ✕
      </button>
    </div>
  );
};

const AttachmentsInput = ({
  attachments,
  uploadFile,
  removeAttachment,
  reorder,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = attachments.findIndex((a) => a.id === active.id);
      const newIndex = attachments.findIndex((a) => a.id === over.id);
      reorder(oldIndex, newIndex);
    }
  };

  const handleFiles = async (e) => {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

    for (const file of files) {
      const fileToUpload = await convertImageToWebp(file);

      console.log("До:", file.size);
      console.log("После:", fileToUpload.size);
      uploadFile(fileToUpload);
    }
  };

  return (
    <div
      className="attachments-zone"
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleFiles}
    >
      <input
        type="file"
        id="attach-input"
        accept="image/*,video/*"
        multiple
        className="file-input"
        onChange={handleFiles}
      />
      <label htmlFor="attach-input" className="attach-label">
        📎 Перетащите или кликните для добавления (до 6)
      </label>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={attachments.map((att) => att.id)}
          strategy={rectSortingStrategy}
        >
          <div className={`attachment-grid grid-${attachments.length}`}>
            {attachments.map((att) => (
              <SortableItem
                key={att.id}
                id={att.id}
                url={att.url}
                mime={att.mime}
                onRemove={removeAttachment}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default AttachmentsInput;
